import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

/* ================= FETCH RATINGS BY ORDER ================= */
export const fetchRatingByOrder = createAsyncThunk(
  "rating/fetchByOrder",
  async (orderNo, thunkAPI) => {
    try {
      /* Addressed by orderNo (legacy_id also matches, so an old bookmarked
         Mongo id still resolves). The payload is the order's whole rating
         card, not one rating:
           { orderNo, orderId, customerId, ratedCount, averageValue, items }
         with one entry in items per rateable PRODUCT on the order — value,
         review, isVisible, forThisOrder, ratedAt are null on an unrated one,
         and ratedCount is 0 when nobody has rated anything. */
      const res = await api.get(`/admin/orders/${orderNo}/ratings`);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || err.response?.data?.code || "Failed to fetch rating"
      );
    }
  }
);

/* ================= SLICE ================= */
const ratingSlice = createSlice({
  name: "rating",
  initialState: {
    loading:     false,
    error:       null,
    /* The order's rating card as the service answers it — see the thunk. It is
       no longer a single flat rating ({ value, review, createdAt }); a card
       with ratedCount 0 is the "nothing rated yet" case. */
    orderRating: null,
  },
  reducers: {
    clearOrderRating: (state) => {
      state.orderRating = null;
      state.error       = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRatingByOrder.pending, (state) => {
        state.loading = true;
        state.error   = null;
      })
      .addCase(fetchRatingByOrder.fulfilled, (state, action) => {
        state.loading     = false;
        state.orderRating = action.payload;
      })
      .addCase(fetchRatingByOrder.rejected, (state, action) => {
        state.loading = false;
        state.error   = action.payload;
      });
  },
});

export const { clearOrderRating } = ratingSlice.actions;
export default ratingSlice.reducer;

/* ================= SELECTORS ================= */
export const selectOrderRating        = (state) => state.rating.orderRating;
export const selectOrderRatingLoading = (state) => state.rating.loading;
export const selectOrderRatingError   = (state) => state.rating.error;